export class Role {
  id: number = 0;
  name: string = '';
  systemComponent: SystemComponents = -1;
  permissions: PermissionsEnum[] = [];
  isDisabled: boolean;
  checked?: boolean;

  constructor(data?: any) {
    this.id = data?.id || 0;
    this.name = data?.name || '';
    this.systemComponent = data?.systemComponent || SystemComponents.Undefined;
    this.permissions = data?.permissions || [];
    this.isDisabled = data?.isDisabled || false;
  }
}
export enum SystemComponents {
  Undefined = -1,
  Admin = 0,
  Mobile = 1,
}

export enum PermissionsEnum {
  Customer_View = 1,
  Customer_CreateEdit = 2,
  Customer_Delete = 3,
  Customer_Assign = 4,
  Customer_ApproveReject = 5,
  Customer_AuditReview = 6,
  Customer_RecallAssigned = 7,
  Customer_ViewCrud = 8,
  Customer_CreateEditCrud = 9,
  Customer_Retag = 10,
  Customer_RecallValidated = 11,
  Customer_Regularization = 12,
  Customer_AssignForDecommission = 13,
  Customer_Unvisited = 14,
  Customer_NewEntryBreakdown = 15,
  Customer_Download = 16,
  Customer_CrudDownload = 17,
  Customer_Review = 18,
  Customer_Sweep = 19,
  Customer_ElectricalAddressCode = 20,
  Customer_PropertyCode = 21,
  Customer_ValidationStatus = 22,
  Customer_AuditStatus = 23,
  Customer_ReviewStatus = 24,
  Customer_ServiceRequestViewCrud = 25,
  Customer_NewEntryViewCrud = 26,
  Customer_FailedSyncNotification = 27,
  Customer_FeederBandAlignmentNotification = 28,
  Customer_GlobalView = 29,

  Transformers_View = 101,
  Transformers_CreateEdit = 102,
  Transformers_Delete = 103,
  Transformers_Assign = 104,
  Transformers_ApproveReject = 105,
  Transformers_AuditReview = 106,
  Transformers_RecallAssigned = 107,
  Transformers_ViewCrud = 108,
  Transformers_CreateEditCrud = 109,
  Transformers_Retag = 110,
  Transformers_RecallValidated = 111,
  Transformers_Download = 112,
  Transformers_ValidationStatus = 113,
  Transformers_AuditStatus = 114,
  Transformers_ReviewStatus = 115,
  Transformers_Review = 116,

  Pole_View = 201,
  Pole_CreateEdit = 202,
  Pole_Delete = 203,
  Pole_Assign = 204,
  Pole_ApproveReject = 205,
  Pole_AuditReview = 206,
  Pole_RecallAssigned = 207,
  Pole_Retag = 208,
  Pole_RecallValidated = 209,
  Pole_Download = 210,
  Pole_Sweep = 211,
  Pole_ValidationStatus = 212,
  Pole_AuditStatus = 213,
  Pole_ReviewStatus = 214,
  Pole_Review = 215,

  Building_View = 301,
  Building_CreateEdit = 302,
  Building_Delete = 303,
  Building_Assign = 304,
  Building_ApproveReject = 305,
  Building_AuditReview = 306,
  Building_RecallAssigned = 307,
  Building_Retag = 308,
  Building_RecallValidated = 309,
  Building_Download = 310,
  Building_Review = 311,
  Building_Sweep = 312,
  Building_ElectricalAddressCode = 313,
  Building_PropertyCode = 314,
  Building_ValidationStatus = 315,
  Building_AuditStatus = 316,
  Building_ReviewStatus = 317,

  Meters_View = 401,
  Meters_CreateEdit = 402,
  Meters_Delete = 403,
  Meters_ApproveReject = 404,
  Meters_Retag = 406,
  Meters_Download = 407,
  Meters_ValidationStatus = 408,
  Meters_AuditStatus = 409,
  Meters_ReviewStatus = 410,

  Survey_View = 501,
  Survey_CreateEdit = 502,
  Survey_Delete = 503,
  Survey_ApproveReject = 504,
  Survey_RecallRejected = 505,
  Survey_Create_New = 506,
  Survey_AssignMapVendor = 507,
  Survey_AssignToVendor = 508,
  Survey_RecallApproved = 509,
  Installation_View = 601,
  Installation_CreateEdit = 602,
  Installation_Delete = 603,
  Installation_ApproveReject = 604,
  Installation_Recall = 605,
  DtMeterInstallation_View = 606,
  DtMeterInstallation_CreateEdit = 607,
  DtMeterInstallation_Delete = 608,
  DtMeterInstallation_ApproveReject = 609,
  DtMeterInstallation_Recall = 610,
  DtMeterInstallation_AcceptDecline = 611,
  DtMeterInstallation_ApproveMeter = 612,
  DtMeterInstallation_ApproveInvoice = 613,
  DtMeterInstallation_RecallAwaitingApproval = 614,
  DtMeterInstallation_AcknowledgeRepayment = 615,
  DtMeterInstallation_ViewMeterApproval = 616,
  DtMeterInstallation_ViewInvoiceApproval = 617,
  DtMeterInstallation_ViewActiveRepayment = 618,
  DtMeterInstallation_ViewCompletedPayment = 619,
  DtMeterInstallation_CreateNew = 620,
  DtMeterInstallation_AuthorizeMetering = 621,
  DtMeterInstallation_VendorAssignment = 622,
  DtMeterInstallation_DeclineReport = 623,
  UserManagement_View = 701,
  UserManagement_CreateEdit = 702,
  UserManagement_Delete = 703,
  UserManagement_BulkAssign = 704,
  UserManagement_Download = 705,
  RoleManagement_View = 801,
  RoleManagement_CreateEdit = 802,
  RoleManagement_Delete = 803,
  Ts_View = 901,
  Ts_CreateEdit = 902,
  Ts_Delete = 903,
  Ts_ValidationStatus = 904,
  Ts_AuditStatus = 905,
  Ts_ReviewStatus = 906,
  F33_View = 1001,
  F33_CreateEdit = 1002,
  F33_Delete = 1003,
  F33_ValidationStatus = 1004,
  F33_AuditStatus = 1005,
  F33_ReviewStatus = 1006,
  Ss_View = 1101,
  Ss_CreateEdit = 1102,
  Ss_Delete = 1103,
  Ss_ValidationStatus = 1104,
  Ss_AuditStatus = 1105,
  Ss_ReviewStatus = 1106,
  F11_View = 1201,
  F11_CreateEdit = 1202,
  F11_Delete = 1203,
  F11_ValidationStatus = 1204,
  F11_AuditStatus = 1205,
  F11_ReviewStatus = 1206,
  Area_View = 1301,
  Area_CreateEdit = 1302,
  Area_Delete = 1303,
  Region_View = 1401,
  Region_CreateEdit = 1402,
  Region_Delete = 1403,
  MeterType_View = 1501,
  MeterType_CreateEdit = 1502,
  MeterType_Delete = 1503,
  AssetRating_View = 1601,
  AssetRating_CreateEdit = 1602,
  AssetRating_Delete = 1603,
  AssetStatus_View = 1701,
  AssetStatus_CreateEdit = 1702,
  AssetStatus_Delete = 1703,
  DtMeterType_View = 1801,
  DtMeterType_CreateEdit = 1802,
  DtMeterType_Delete = 1803,
  Tariff_View = 1901,
  Tariff_CreateEdit = 1902,
  Tariff_Delete = 1903,
  AuditLog_View = 2001,
  AuditLog_Download = 2002,
  MeterPrice_View = 2101,
  MeterPrice_CreateEdit = 2102,
  MeterPrice_Delete = 2103,

  Disconnection = 3001,

  AuditStatus = 4001,
  ValidationStatus = 4002,
  ReviewStatus = 4003,

  SiteVerification = 5001,
  Maintenance = 5002,

  Slt_View = 6001,
  Slt_CreateEdit = 6002,
  Slt_Delete = 6003,

  Outages = 7001,
  Organization_Create = 8001,

  CustomerMeterStockInventory_View = 9001,
  CustomerMeterStockInventory_Create = 9002,
  CustomerMeterStockInventory_ViewUtilizationStock = 9003,

  CustomerDecommissionedMeterStock_View = 9004,
  CustomerDecommissionedMeterStock_Approve = 9005,
  CustomerDecommissionedMeterStock_Edit = 9006,

  AssetMeterStockInventory_View = 9007,
  AssetMeterStockInventory_Create = 9008,
  AssetMeterStockInventory_ViewUtilizationStock = 9009,

  CtvtMeterStockInventory_View = 9010,
  CtvtMeterStockInventory_Create = 9011,
  CtvtMeterStockInventory_ViewUtilizationStock = 9012,

  MeterReading = 10000,

  BillingAccounts_View = 11000,
  BillingAccounts_CreateEdit = 11001,
  BillingAccounts_Delete = 11002,

  Report_Misaligned = 12000,
  Report_DataQualityRejection = 12001,
  Report_Regularization = 12002,

  SearchEngine = 13000,

  Map_View = 14000,

  Rmus_View = 15001,
  Rmus_CreateEdit = 15002,
  Rmus_Delete = 15003,
  Rmus_Assign = 15004,
  Rmus_ApproveReject = 15005,
  Rmus_AuditReview = 15006,
  Rmus_RecallAssigned = 15007,
  Rmus_ViewCrud = 15008,
  Rmus_CreateEditCrud = 15009,
  Rmus_Retag = 15010,
  Rmus_RecallValidated = 15011,
  Rmus_Download = 15012,
  Rmus_ValidationStatus = 15013,
  Rmus_AuditStatus = 15014,
  Rmus_ReviewStatus = 15015,

  NewService_View = 16001,
  NewService_CreateEdit = 16002,
  NewService_Download = 16003,
  NewService_Delete = 16004,
  NewService_ApproveReject = 16005,
  NewService_BulkUpload = 16006,
  NewService_RecallValidated = 16007,
  NewService_HighCapacity = 16008,
  NewService_StandardCapacity = 16009,

  Dashboard_AnalyticsOverview = 17001,
  Dashboard_OperationsAnalytics = 17002,
  Dashboard_MeterValidation = 17003,

  Meter_Validation_View = 18001,
  Meter_Validation_CreateEdit = 18002,
  Meter_Validation_ApproveReject = 18003,

  DroneMap_View = 19000,

  MVPole_View = 20001,
  MVPole_CreateEdit = 20002,
  MVPole_Delete = 20003,
  MVPole_Assign = 20004,
  MVPole_ApproveReject = 20005,
  MVPole_AuditReview = 20006,
  MVPole_RecallAssigned = 20007,
  MVPole_Retag = 20008,
  MVPole_RecallValidated = 20009,
  MVPole_Download = 20010,
  MVPole_ValidationStatus = 20011,
  MVPole_AuditStatus = 20012,
  MVPole_ReviewStatus = 20013,

  HVPole_View = 21001,
  HVPole_CreateEdit = 21002,
  HVPole_Delete = 21003,
  HVPole_Assign = 21004,
  HVPole_ApproveReject = 21005,
  HVPole_AuditReview = 21006,
  HVPole_RecallAssigned = 21007,
  HVPole_Retag = 21008,
  HVPole_RecallValidated = 21009,
  HVPole_Download = 21010,
  HVPole_ValidationStatus = 21011,
  HVPole_AuditStatus = 21012,
  HVPole_ReviewStatus = 21013,

  DataModelCustomization_View = 22001,
  DataModelCustomization_CreateEdit = 22002,
  DataModelCustomization_Delete = 22003,

  SiteVerification_CreateEdit = 23001,
  SiteVerification_Download = 23002,
  SiteVerification_Validation = 23003,
  SiteVerification_RecallAssigned = 23004,
  SiteVerification_RecallValidated = 23005,
  SiteVerification_SiteVerification = 23006,
  SiteVerification_View = 23007,
  SiteVerification_ApproveReject = 23008,
  SiteVerification_HighCapacity = 23009,
  SiteVerification_StandardCapacity = 23010,

  ServiceRequestAuth_CreateEdit = 24001,
  ServiceRequestAuth_Download = 24002,
  ServiceRequestAuth_BulkUpload = 24003,
  ServiceRequestAuth_Validation = 24004,
  ServiceRequestAuth_HighCapacity = 24005,
  ServiceRequestAuth_StandardCapacity = 24006,
  ServiceRequestAuth_View = 24007,

  OnboardedCustomers_CreateEdit = 25001,
  OnboardedCustomers_Download = 25002,
  OnboardedCustomers_AssignToVendor = 25003,
  OnboardedCustomers_HighCapacity = 25004,
  OnboardedCustomers_StandardCapacity = 25005,
  OnboardedCustomers_View = 25006,

  CustomerReadings_Usage = 300001,
  CustomerReadings_Failed = 300002,
  CustomerReadings_Rejected = 300003,
  CustomerReadings_Inaccessible = 300004,
  CustomerReadings_Inoperable = 300005,

  AssetReadings_Usage = 310001,
  AssetReadings_Failed = 310002,
  AssetReadings_Rejected = 310003,
  AssetReadings_Inaccessible = 310004,
  AssetReadings_Inoperable = 310005,

  AssignedReadings_Usage = 320001,
  AssignedReadings_Failed = 320002,
  AssignedReadings_Rejected = 320003,
  AssignedReadings_Inaccessible = 320004,
  AssignedReadings_Inoperable = 320005,

  ReadingsSchedule_Usage = 330001,
  ReadingsSchedule_Failed = 330002,
  ReadingsSchedule_Rejected = 330003,
  ReadingsSchedule_Inaccessible = 330004,
  ReadingsSchedule_Inoperable = 330005,

  AI_UAV_Overview = 34001,
  AI_UAV_Batch_Image_Import = 34002,
  AI_UAV_Segmentation_List = 34003,
  AI_UAV_Job_Monitoring = 34004,

  Readings_View = 35001,

  NetworkStructure_View = 36001,
  NetworkStructure_CreateEdit = 36002,
  NetworkStructure_Assign = 36003,
  NetworkStructure_ApproveReject = 36004,
  NetworkStructure_Review = 36005,
  NetworkStructure_AuditReview = 36006,
  NetworkStructure_RecallValidated = 36007,
  NetworkStructure_RecallAssigned = 36008,
  NetworkStructure_Download = 36009,
  NetworkStructure_Delete = 36010,
  NetworkStructure_GisReview = 36011,

  NetworkEntityClasses_View = 37001,
  NetworkEntityClasses_CreateEdit = 37002,
  NetworkEntityClasses_Delete = 37003,

  MeterAssignment_View = 38001,
  MeterAssignment_CreateEdit = 38002,
  MeterAssignment_Delete = 38003,

  PaymentHistory_View = 39001,
  PaymentHistory_Download = 39002,

  ServiceRequestTracker_View = 40001,

  AuditTrail_View = 41001,
  AuditTrail_Download = 41002,

  AiChat_Use = 42001,

  Settlement_View = 43001,
  Settlement_Download = 43002,

  SchematicDiagram_View = 44001,
  SchematicDiagram_CreateEdit = 44002,
}
